var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { v4 as uuidv4 } from "uuid";
import { createContext, useMemo, useContext, useState, useCallback, useEffect, } from "react";
import { NotificationTypeBanner } from "../components/Notifications/NotificationTypeBanner";
var NotificationContext = createContext({
    notify: function () { },
});
var NOTIFICATION_DURATION_MS = 5000;
var NOTIFICATION_DELAY_MS = 500;
export var NotificationsProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), notifications = _b[0], setNotifications = _b[1];
    var removeNotification = useCallback(function (id) {
        var clearedNotifications = notifications.filter(function (n) { return n.id !== id; });
        setNotifications(clearedNotifications);
    }, [notifications]);
    useEffect(function () {
        var lastNotificationElement = notifications[notifications.length - 1];
        var timeout = setTimeout(function () {
            if (lastNotificationElement) {
                removeNotification(lastNotificationElement.id);
            }
        }, NOTIFICATION_DURATION_MS);
        return function () {
            clearTimeout(timeout);
        };
    }, [notifications]);
    var value = useMemo(function () {
        var notify = function (type, text) {
            var id = uuidv4();
            var notification = { id: id, type: type, text: text };
            setTimeout(function () {
                setNotifications(__spreadArray([notification], notifications, true));
            }, NOTIFICATION_DELAY_MS);
        };
        return {
            notify: notify,
            notifications: notifications,
        };
    }, [notifications, removeNotification]);
    return (_jsxs(NotificationContext.Provider, __assign({ value: value }, { children: [_jsx("div", __assign({ className: "fixed bottom-0 left-0 right-0 z-150 w-full" }, { children: notifications.map(function (n) { return (_jsx(NotificationTypeBanner, { type: n.type, text: n.text, onClose: function () { return removeNotification(n.id); } }, n.id)); }) })), children] })));
};
export var useNotifications = function () { return useContext(NotificationContext); };
